<template>
  <div id="about" class="container section scrollspy section-about">
    <div class="row card-about-container">
      
      <div class="col m6 s12 info-text-col">
        <h2 class="title-about">Sobre mí</h2>
        <div class="divider-left"></div>
        <div class="subtitle-about">
          Desarrollador de Software Fullstack & Mobile
        </div>

        <div class="cuerpoTexto">
          <p>
            Soy <strong>Cristhian Vera Almeida</strong>. Con más de 
            <strong>{{ añosExperiencia }} años de trayectoria</strong>, me especializo en el diseño y arquitectura de software 
            utilizando un ecosistema robusto centrado en <strong>Angular, Flutter, NestJS, NextJS y Python</strong>.
          </p>
          <p>
            Mi enfoque principal es construir soluciones escalables y de alto rendimiento. Cuento con un stack técnico 
            versátil que abarca desde el desarrollo frontend y móvil hasta arquitecturas backend sólidas, permitiéndome 
            entregar productos eficientes que cumplen con los más altos estándares de la industria.
          </p>
          
          <div class="btn-container">
            <a class="waves-effect waves-light btn green darken-1 btn-large z-depth-2" 
               href="https://cristhianveal.my.canva.site/cv" 
               target="_blank">
              <i class="material-icons left">visibility</i>Visualizar CV
            </a>
          </div>
        </div>
      </div>

      <div class="col m6 s12 skills-col">
        <div class="skills-card z-depth-1">
          <div class="subtitle-skills">Stack Tecnológico</div>
          <div class="row flex-container-skills">
            <div class="col m3 s4 itemsHabilidades" 
                 v-for="(conocimiento, index) in conocimientos" 
                 :key="index">
              <div class="skill-wrapper">
                <img :src="conocimiento.asset" 
                     :alt="conocimiento.titulo" 
                     class="skill-icon" />
                <span class="skill-tooltip">{{ conocimiento.titulo }}</span>
              </div>
              <h6 class="skill-title">{{ conocimiento.titulo }}</h6>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'SobreMi',
  data() {
    return {
      conocimientos: [
        { titulo: "Angular", asset: "/./img/icons/angular.gif" },
        { titulo: "Flutter", asset: "/./img/icons/flutter.svg" },
        { titulo: "NestJS", asset: "/./img/icons/NestJS.svg" },
        { titulo: "NextJS", asset: "/./img/icons/next-js.svg" },
        { titulo: "React", asset: "/./img/icons/react.svg" },
        { titulo: "Vue", asset: "/./img/icons/vue.svg" },
        { titulo: "JavaScript", asset: "/./img/icons/javascript.svg" },
        { titulo: "TypeScript", asset: "/./img/icons/Typescript.png" },
        { titulo: "Python", asset: "/./img/icons/python.png" },
        { titulo: "PHP", asset: "/./img/icons/php.svg" },
        { titulo: "Firebase", asset: "/./img/icons/firebase.svg" },
        { titulo: "GitHub", asset: "/./img/icons/github.svg" },
        { titulo: "HTML", asset: "/./img/icons/html.svg" },
        { titulo: "CSS", asset: "/./img/icons/css.svg" },
      ],
    };
  },
  computed: {
    añosExperiencia() {
      const fechaInicio = new Date('2021-04-01');
      const fechaActual = new Date();
      let diferencia = fechaActual.getFullYear() - fechaInicio.getFullYear();
      const mes = fechaActual.getMonth() - fechaInicio.getMonth();
      if (mes < 0 || (mes === 0 && fechaActual.getDate() < fechaInicio.getDate())) {
        diferencia--;
      }
      return diferencia;
    }
  }
};
</script>

<style scoped>
.section-about {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

/* Títulos y Texto */
.title-about {
  color: var(--colorSecundario);
  font-size: 45px;
  font-weight: 800;
  margin: 0;
  text-transform: uppercase;
}

.divider-left {
  height: 5px;
  width: 60px;
  background-color: var(--colorPrincipal);
  margin: 15px 0;
}

.subtitle-about {
  color: var(--colorSecundario);
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 25px;
  opacity: 0.9;
}

.cuerpoTexto {
  font-size: 17px;
  text-align: justify;
  line-height: 1.8;
  color: #444;
}

/* Contenedor de Habilidades */
.skills-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 15px;
  border: 1px solid rgba(0,0,0,0.05);
}

.subtitle-skills {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--colorSecundario);
  text-align: center;
  margin-bottom: 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.flex-container-skills {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

/* Items de Habilidades */
.skill-wrapper {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: default;
}

.itemsHabilidades {
  text-align: center;
  margin-bottom: 15px;
}

.itemsHabilidades:hover .skill-wrapper {
  background: white;
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.skill-icon {
  height: 45px;
  width: 45px;
  object-fit: contain;
}

.skill-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #666;
  margin-top: 10px;
}

.btn-container {
  margin-top: 40px;
}

/* Responsividad */
@media only screen and (max-width: 600px) {
  .title-about { font-size: 32px; text-align: center; }
  .divider-left { margin: 15px auto; }
  .subtitle-about { text-align: center; font-size: 20px; }
  .info-text-col { margin-bottom: 50px; }
}
</style>